module.exports = __webpack_public_path__ + "linux.png";